export default __webpack_public_path__ + "static/sust-fourth-af1ec070446a3394be466efaf7de8e7b.png";